import {Getters} from "vuex-smart-module";
import AccessControlState from "@/store/modules/access-control/access-control-state";
import AccessControlDeviceData from "@/http/data/access-control-device-data";
import AccessControlCardData from "@/http/data/access-control-card-data";
import AccessControlEventPageData from "@/http/data/access-control-event-page-data";
import AccessControlDoorData from "@/http/data/access-control-door-data";

export default class AccessControlGetters extends Getters<AccessControlState> {
    get selectedDevice(): AccessControlDeviceData | null {
        if (!this.state.selectedDeviceId) return null;

        return this.state.deviceDetailsById[this.state.selectedDeviceId]
            ?? this.state.devices.find(device => device.device_id === this.state.selectedDeviceId)
            ?? null;
    }

    get selectedCard(): AccessControlCardData | null {
        if (!this.state.selectedDeviceId || !this.state.selectedCardNumber) return null;

        const deviceCards = this.state.cardDetailsByDeviceId[this.state.selectedDeviceId];

        return deviceCards ? deviceCards[this.state.selectedCardNumber] ?? null : null;
    }

    get cardsForSelectedDevice(): number[] {
        if (!this.state.selectedDeviceId) return [];

        return this.state.cardNumbersByDeviceId[this.state.selectedDeviceId] ?? [];
    }

    get doorsForSelectedDevice(): AccessControlDoorData[] {
        if (!this.state.selectedDeviceId) return [];

        return this.state.doorsByDeviceId[this.state.selectedDeviceId] ?? [];
    }

    get selectedDoor(): AccessControlDoorData | null {
        if (!this.state.selectedDeviceId || !this.state.selectedDoorId) return null;

        const deviceDoors = this.state.doorDetailsByDeviceId[this.state.selectedDeviceId];

        return deviceDoors ? deviceDoors[this.state.selectedDoorId] ?? null : null;
    }

    get eventsPageForSelectedDevice(): AccessControlEventPageData | null {
        if (!this.state.selectedDeviceId) return null;

        const devicePages = this.state.eventsPagesByDeviceId[this.state.selectedDeviceId];

        if (!devicePages) return null;

        return devicePages[this.state.selectedEventsPageNumber] ?? null;
    }
}
